import { render } from "./packfore.vue?vue&type=template&id=70766018&scoped=true"
import script from "./packfore.vue?vue&type=script&lang=js"
export * from "./packfore.vue?vue&type=script&lang=js"

import "./packfore.vue?vue&type=style&index=0&id=70766018&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70766018"]])

export default __exports__